export enum PaymentPlan {
  BRONZE = 'BRONZE',
  SILVER = 'SILVER',
  GOLD = 'GOLD',
  PLATINUM = 'PLATINUM',
  STARTER = 'STARTER',
  BASIC = 'BASIC',
  ENTREPRISE = 'ENTREPRISE',
  WHITELABEL = 'WHITELABEL',
  DISCOUNTED = 'DISCOUNTED'
}